import { render } from "./TestResultModal.vue?vue&type=template&id=2b30962e&ts=true"
import script from "./TestResultModal.vue?vue&type=script&lang=ts"
export * from "./TestResultModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__